module.exports = __webpack_public_path__ + "fonts/Montserrat-Regular.3fe868a1.ttf";